import { Link } from 'react-router-dom';
import { ROUTES } from '../lib/constants';
import logoImg from '../assets/logo.png';
import Footer from '../components/common/Footer';

export default function Index() {
    return (
        <div className="min-h-screen bg-white">

            {/* ... (Previous Sections) ... */}

            {/* O conteúdo anterior do componente Index permanece inalterado até o footer */}

            {/* Header */}
            <header className="bg-white container mx-auto px-4 py-6">
                <nav className="flex justify-between items-center">
                    <Link to={ROUTES.HOME} className="flex items-center gap-3">
                        <img src={logoImg} alt="Fila0 Logo" className="h-20 w-auto object-contain" />
                    </Link>
                    <Link to={ROUTES.LOGIN} className="btn btn-outline">
                        Entrar
                    </Link>
                </nav>
            </header>

            {/* Hero Section with Light Green Background */}
            <section className="bg-gradient-to-b from-green-50 to-white py-20">
                <div className="container mx-auto px-4 text-center">
                    <div className="max-w-4xl mx-auto animate-fade-in">
                        <h1 className="text-5xl md:text-6xl font-bold text-textPrimary mb-6">
                            Acabou a fila na <span className="text-primary">saída da escola</span>
                        </h1>
                        <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
                            Sistema simples e eficiente para gestão de buscas escolares.
                            Os pais avisam quando estão chegando, a escola prepara o aluno.
                            <strong className="text-success"> Fila 0!</strong>
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                            <Link to={ROUTES.DEMO} className="btn btn-primary text-lg px-8 py-4">
                                Ver Demonstração 🎯
                            </Link>
                            <Link to={ROUTES.LOGIN} className="btn btn-outline text-lg px-8 py-4">
                                Entrar
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* How it Works Section */}
            <section className="container mx-auto px-4 py-20">
                <h2 className="text-4xl font-bold text-center mb-16 text-textPrimary">
                    Como funciona?
                </h2>

                <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                    {/* Step 1 */}
                    <div className="card text-center animate-slide-up" style={{ animationDelay: '0.1s' }}>
                        <div className="text-6xl mb-4">🚗</div>
                        <h3 className="text-2xl font-semibold mb-3 text-textPrimary">1. Responsável avisa</h3>
                        <p className="text-gray-600">
                            Quando estiver chegando na escola, clique em <strong>"Estou chegando"</strong> no app
                        </p>
                    </div>

                    {/* Step 2 */}
                    <div className="card text-center animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        <div className="text-6xl mb-4">📝</div>
                        <h3 className="text-2xl font-semibold mb-3 text-textPrimary">2. Escola prepara</h3>
                        <p className="text-gray-600">
                            A escola recebe a notificação em tempo real e começa a preparar o aluno
                        </p>
                    </div>

                    {/* Step 3 */}
                    <div className="card text-center animate-slide-up" style={{ animationDelay: '0.3s' }}>
                        <div className="text-6xl mb-4">🎉</div>
                        <h3 className="text-2xl font-semibold mb-3 text-textPrimary">3. Fila 0!</h3>
                        <p className="text-gray-600">
                            Quando você chegar, o aluno já estará pronto. Sem filas, sem espera!
                        </p>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="bg-gray-50 py-20">
                <div className="container mx-auto px-4">
                    <h2 className="text-4xl font-bold text-center mb-16 text-textPrimary">
                        Por que usar o Fila0?
                    </h2>

                    <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                        <div className="flex gap-4">
                            <div className="text-3xl">⚡</div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Rápido e Simples</h3>
                                <p className="text-gray-600">Um clique para avisar que está chegando. Não pode ser mais fácil!</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="text-3xl">⏰</div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Economize Tempo</h3>
                                <p className="text-gray-600">Sem mais espera em filas. Seu tempo é valioso!</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="text-3xl">🔔</div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Tempo Real</h3>
                                <p className="text-gray-600">A escola vê seu aviso instantaneamente</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="text-3xl">📱</div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2">PWA Moderno</h3>
                                <p className="text-gray-600">Funciona no celular como um app nativo</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="container mx-auto px-4 py-20 text-center">
                <div className="max-w-3xl mx-auto card bg-gradient-to-r from-primary to-blue-600 text-white">
                    <h2 className="text-4xl font-bold mb-6">
                        Pronto para eliminar as filas?
                    </h2>
                    <p className="text-xl mb-8 opacity-90">
                        Experimente agora a demonstração interativa e veja como é simples!
                    </p>
                    <Link to={ROUTES.DEMO} className="btn bg-white text-primary hover:bg-gray-100 text-lg px-8 py-4">
                        Ver Demonstração Agora →
                    </Link>
                </div>
            </section>

            {/* Footer */}
            <Footer />
        </div>
    );
}
